import React, { useState, useEffect, useCallback } from "react";
import useEmblaCarousel from "embla-carousel-react";
import { ChevronLeft, ChevronRight, Quote } from "lucide-react";
import { TESTIMONIALS } from "../mock/mock";
import { imageUrl } from "../lib/api";

export default function TestimonialCarousel() {
  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true, align: "start" });
  const [, setSel] = useState(0);

  const scrollPrev = useCallback(() => emblaApi && emblaApi.scrollPrev(), [emblaApi]);
  const scrollNext = useCallback(() => emblaApi && emblaApi.scrollNext(), [emblaApi]);

  useEffect(() => {
    if (!emblaApi) return;
    const onSel = () => setSel(emblaApi.selectedScrollSnap());
    emblaApi.on("select", onSel);
    const id = setInterval(() => emblaApi.scrollNext(), 6000);
    return () => {
      emblaApi.off("select", onSel);
      clearInterval(id);
    };
  }, [emblaApi]);

  return (
    <div className="relative">
      <div className="overflow-hidden" ref={emblaRef}>
        <div className="flex">
          {TESTIMONIALS.map((t, i) => (
            <div
              key={i}
              className="flex-[0_0_100%] md:flex-[0_0_50%] lg:flex-[0_0_33.33%] px-3"
            >
              <div className="relative h-[460px] rounded-md overflow-hidden group">
                <img
                  src={imageUrl(t.image)}
                  alt={t.car}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/70 to-black/10" />
                <div className="absolute inset-0 p-7 flex flex-col justify-end">
                  <Quote className="w-7 h-7 text-[#c5a76f] mb-3" />
                  <h3 className="text-white text-2xl font-bold mb-3" style={{ fontFamily: "'Familjen Grotesk', serif" }}>
                    {t.car}
                  </h3>
                  <p className="text-white/85 text-sm leading-relaxed mb-4 line-clamp-5">
                    {t.text}
                  </p>
                  <div className="text-[#c5a76f] text-sm font-semibold tracking-wide">
                    — {t.author}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <button
        onClick={scrollPrev}
        className="absolute -left-2 md:-left-6 top-1/2 -translate-y-1/2 w-11 h-11 rounded-full bg-black/70 border border-[#c5a76f]/40 text-[#c5a76f] flex items-center justify-center hover:bg-[#c5a76f] hover:text-black transition-colors z-10"
        aria-label="Previous"
      >
        <ChevronLeft className="w-5 h-5" />
      </button>
      <button
        onClick={scrollNext}
        className="absolute -right-2 md:-right-6 top-1/2 -translate-y-1/2 w-11 h-11 rounded-full bg-black/70 border border-[#c5a76f]/40 text-[#c5a76f] flex items-center justify-center hover:bg-[#c5a76f] hover:text-black transition-colors z-10"
        aria-label="Next"
      >
        <ChevronRight className="w-5 h-5" />
      </button>
    </div>
  );
}
